module.exports = __webpack_public_path__ + "img/31.2f57baf5.svg";